export default __webpack_public_path__ + "static/media/topomap_norm.b1f2687f.webp";